export default "__VITE_ASSET__5d9b4f8f__"